import React, { Component } from 'react';
import _ from 'lodash';
import TagCloud from 'react-tag-cloud';
import randomColor from 'randomcolor';
import { updateTagId, projectListingGrid } from "../../actions/DashboardAction";
import { connect } from 'react-redux';

class WordCloud extends Component {

    constructor(props) {
        super(props);
        this.state = {
            tagStyle : {},
            tagPadding: 10
        };
    }

    /**
     * On component mount
     */
    componentWillMount() {
        const set1 = [30, 36, 44, 56, 72];
        const set2 = [24, 30, 36, 44, 56];
        const set3 = [20, 24, 30, 36, 44];
        const set4 = [18, 20, 24, 30, 36];
        const set5 = [15, 18, 20, 24, 30];
        let tagStyle = this.setFontSizes(set1);

        const {tagCloudDetail} = this.props;
        if(_.isEmpty(tagCloudDetail) == false && tagCloudDetail.length > 0){
            let grt18 = tagCloudDetail.filter(tag => tag.tagCount >= 18);
            let grt12 = tagCloudDetail.filter(tag => tag.tagCount >= 12);
            if(tagCloudDetail.length >= 25){
                if(grt18.length > 30 || grt12.length > 20){
                    tagStyle = this.setFontSizes(set3);
                }else if(grt18.length > 20 || grt12.length > 10){
                    tagStyle = this.setFontSizes(set2);
                }else if(grt18.length > 10 || grt12.length > 5){
                    tagStyle = this.setFontSizes(set1);
                }else if(grt18.length > 5){
                    tagStyle = this.setFontSizes(set1);
                }else{
                    tagStyle = this.setFontSizes(set1);
                }
            }else if(tagCloudDetail.length >= 15){
                if(grt18.length > 10){
                    tagStyle = this.setFontSizes(set3);
                }else if(grt18.length > 5){
                    tagStyle = this.setFontSizes(set2);
                }else{
                    tagStyle = this.setFontSizes(set1);
                }
            }else{
                if(grt18.length > 5){
                    tagStyle = this.setFontSizes(set2);
                }else{
                    tagStyle = this.setFontSizes(set1);
                }
            }
        }


        if(this.props.platform == 'mobile') {
            //tagStyle = this.setFontSizes([12, 15, 22, 28, 36]);
            tagStyle = this.setFontSizes([13, 18, 23, 28, 33]);

            this.setState({
                tagPadding: 6
            });
        }

        this.setState({
            tagStyle: tagStyle
        });
    }

    /**
     * Just for testing the click even. This will be use for project link
     */

    clickMe = (tagId, tagName) => {
        if(this.props.platform == 'mobile') {
            window.postMessage(tagId, "*");
        } else {
            this.props.onClick(tagId, tagName);
        }
    };

    /**
     * rendomly return rotate text value either 90 or 0 only.
     */
    rotateAngle(max){
        let mx = max.tagCount;
        let randomValue =  Math.floor(Math.random() * Math.floor(mx));
        if(randomValue < (mx-randomValue)){
            return 0;
        }else{
            return 90;
        }

        /*if(max.length <= 7){
            return 90;
        } else {
            return 0;
        }*/
    }

    /**
     * Set font size of cloud tag
     * @param sizes
     * @returns {{style1: {fontSize: *, cursor: string}, style2: {fontSize: *, cursor: string}, style3: {fontSize: *, cursor: string}, style4: {fontSize: *, cursor: string}, style5: {fontSize: *, cursor: string}}}
     */
    setFontSizes(sizes) {
        return {
            style1: {
                fontSize: sizes[0],
                cursor: 'pointer'
            },
            style2: {
                fontSize: sizes[1],
                cursor: 'pointer'
            },
            style3: {
                fontSize: sizes[2],
                cursor: 'pointer'
            },
            style4: {
                fontSize: sizes[3],
                cursor: 'pointer'
            },
            style5: {
                fontSize: sizes[4],
                cursor: 'pointer'
            }
        };
    }

    /**
     * Render the component
     * @returns {*}
     */
    render() {
        const tagCloudDetail = (this.props.tagCloudDetail)?this.props.tagCloudDetail:[];
        return (
            <div>
                <div className='app-outer'>
                    <div className='app-inner' style={{background: 'white'}}>
                        <TagCloud
                            className='tag-cloud'
                            spiral='rectangular'
                            style={{
                                fontFamily: 'impactMT',
                                //fontSize: () => Math.round(Math.random() * 100) + 16,
                                //fontSize: 30,
                                color: () => randomColor({
                                    /*hue: ['#F28695', '#B5CE71', '#4060B3', '#9D9999']*/
                                    hue: ['#6BAF55',
                                            '#B243BC',
                                            '#4060B3',
                                            '#9D9999',
                                            '#D47039',
                                            "#5D578F",
                                            "#833C3B",
                                            "#D4626D",
                                            "#289A78",
                                            "#8B6C36",
                                            "#43D2D1",
                                            "#BC9D42"
                                    ]
                                }),
                                padding: this.state.tagPadding
                            }}>
                            {tagCloudDetail.length  > 0 && tagCloudDetail.map(tag=>{
                                if(tag.tagCount>0 && tag.tagCount<=4){
                                    return <div key={tag.tagId} style={this.state.tagStyle.style1} onClick={() => this.clickMe(tag.tagId, tag.tagName)} rotate={this.rotateAngle(tag)}>{tag.tagName}</div>
                                }else if(tag.tagCount>4 && tag.tagCount<=8){
                                    return <div key={tag.tagId} style={this.state.tagStyle.style2} onClick={() => this.clickMe(tag.tagId, tag.tagName)} rotate={this.rotateAngle(tag)} >{tag.tagName}</div>
                                }else if(tag.tagCount>8 && tag.tagCount<=12){
                                    return <div key={tag.tagId} style={this.state.tagStyle.style3} onClick={() => this.clickMe(tag.tagId, tag.tagName)} rotate={this.rotateAngle(tag)}>{tag.tagName}</div>
                                }else if(tag.tagCount>12 && tag.tagCount<=18){
                                    return <div key={tag.tagId} style={this.state.tagStyle.style4} onClick={() => this.clickMe(tag.tagId, tag.tagName)} rotate={this.rotateAngle(tag)}>{tag.tagName}</div>
                                }else if(tag.tagCount>18){
                                    return <div key={tag.tagId} style={this.state.tagStyle.style5} onClick={() => this.clickMe(tag.tagId, tag.tagName)} rotate={this.rotateAngle(tag)}>{tag.tagName}</div>
                                }
                            })}
                        </TagCloud>
                    </div>
                </div>
            </div>
        );
    }
}
function mapStateToProps(state) {
  return {

  };
}

export default connect(mapStateToProps, {updateTagId, projectListingGrid})(WordCloud);



// WEBPACK FOOTER //
// ./components/Common/WordCloud.js